module.exports = __webpack_public_path__ + "img/gabon.b70dd22.webp";